import { effect, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RepoService } from './repo.service';
import { OauthService, UserInfo } from './oauth.service';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {
  constructor(private repoService: RepoService, private oauthService: OauthService) {
    this.oauthService.userSignIn$.subscribe(async (user: UserInfo | null) => {
      this.user = user;
      if(!user) {
        this.user = await this.oauthService.getUser();
      }
    });
    effect(() => {
      this.serverUrlSubject.next(this.repoService.repo()?.url || '');
    });
  }
  user: UserInfo | null = null;

  private serverUrlSubject = new BehaviorSubject<string>('');
  serverUrl$ = this.serverUrlSubject.asObservable();

  savedInstructions: string = '';
  uiThemePreference: string = '';

  get serverUrl(): string {
    return this.serverUrlSubject.value;
  }

  // updateRepoServerUrl(url: string): void {
  //   localStorage.setItem('repoServerUrl', url);
  //   this.serverUrlSubject.next(url);
  // }
}
